import type {
  CreateWorkspaceTemplateResponse,
  UpdateWorkspaceTemplateResponse,
} from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

export function createWorkspaceTemplate(
  transport: Transport,
  { workspaceId, name, template }: { workspaceId: string; name: string; template: string },
): Promise<CreateWorkspaceTemplateResponse> {
  return operations.postWorkspacesTemplates(transport, { workspaceId, body: { name, template } });
}

export function updateWorkspaceTemplate(
  transport: Transport,
  {
    workspaceId,
    templateId,
    name,
    template,
  }: { workspaceId: string; templateId: string; name: string; template: string },
): Promise<UpdateWorkspaceTemplateResponse> {
  return operations.patchWorkspacesTemplates(transport, { workspaceId, templateId, body: { name, template } });
}

export function deleteWorkspaceTemplate(
  transport: Transport,
  { workspaceId, templateId }: { workspaceId: string; templateId: string },
): Promise<void> {
  return operations.deleteWorkspacesTemplates(transport, { workspaceId, templateId });
}
